import { gql } from '@apollo/client';
const GET_CURRENT_TENANT_CATEGORIES = gql `
  query GetCurrentTenantCategories($first: Int = 20, $after: String = "") {
    me {
      id
      currentTenant {
        id
        categories(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              name
              image
              canNameBeUpdated
              canBeRemoved
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_CATEGORIES;
